// import React from "react";
import IMG9565 from "../images/IMG-9565.jpg";
import IMG9573 from "../images/IMG-9573.JPG";
import IMG9582 from "../images/IMG-9582.jpg";

const data = {
    "properties": [
        {
            "_id": 1,
            "index": 0,
            "picture": IMG9565
        },
        {
            "_id": 2,
            "index": 1,
            "picture": IMG9573
        },
        {
            "_id": 3,
            "index": 2,
            "picture": IMG9582
        },
        {
            "_id": 4,
            "index": 3,
            "picture": IMG9565
        },
        {
            "_id": 5,
            "index": 4,
            "picture": IMG9573
        },
        {
            "_id": 6,
            "index": 5,
            "picture": IMG9582
        }, {
            "_id": 7,
            "index": 6,
            "picture": IMG9565
        },
        {
            "_id": 8,
            "index": 7,
            "picture": IMG9573
        },
        {
            "_id": 9,
            "index": 8,
            "picture": IMG9582
        }, {
            "_id": 10,
            "index": 9,
            "picture": IMG9565
        },
        {
            "_id": 11,
            "index": 10,
            "picture": IMG9573
        },
        {
            "_id": 12,
            "index": 11,
            "picture": IMG9582
        }, {
            "_id": 13,
            "index": 12,
            "picture": IMG9565
        },
        {
            "_id": 14,
            "index": 13,
            "picture": IMG9573
        },
        {
            "_id": 15,
            "index": 14,
            "picture": IMG9582
        }, {
            "_id": 16,
            "index": 15,
            "picture": IMG9565
        },
        {
            "_id": 17,
            "index": 16,
            "picture": IMG9573
        },
        {
            "_id": 18,
            "index": 17,
            "picture": IMG9582
        }
    ]
}
export default data;